import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import styled from "styled-components";

import { Breadcrumb } from "antd";

import PropertiesForms from "./components/properties-forms";
import PropertiesList from "./components/properties-list";

export const StyledBreadcrumb = styled(Breadcrumb)`
    background: #fff;
    display: flex;
    padding: 16px 25px;
`;

const ManageProperties = (): JSX.Element => {
    const match = useRouteMatch();
    return (
        <>
            <Switch>
                <Route
                    exact
                    path={`${match.path}`}
                    render={(props: any) => <PropertiesList {...props} />}
                />
                <Route
                    exact
                    path={`${match.path}/add`}
                    render={(props: any) => <PropertiesForms {...props} />}
                />
                <Route
                    exact
                    path={`${match.path}/add/:propertyType`}
                    render={(props: any) => <PropertiesForms {...props} />}
                />
                <Route
                    exact
                    path={`${match.path}/:slug`}
                    render={(props: any) => <PropertiesForms {...props} />}
                />
            </Switch>
        </>
    );
};

export default ManageProperties;
